// extracted by mini-css-extract-plugin
export default {"button":"CustomButton_button__MXzZ8","dark":"CustomButton_dark__xJc4Z","disabled":"CustomButton_disabled__KoHss"};